import { GET_VISIBLE_UNITS } from '@/graphql/querys/getVisibleUnits';
import { useSuspenseQuery } from '@apollo/client';

export const useSuspenseVisibleUnits = (userId?: number) => {
  const { data } = useSuspenseQuery(GET_VISIBLE_UNITS, {
    variables: userId ? { id: userId } : undefined,
  });

  return data.user.preferences.visibleUnits;
};
